var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13591",
    "data-name": "Group 13591",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.332,
    height: 20.534,
    viewBox: "0 0 19.332 20.534",
    style: {
      transform: "scale(0.7)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11130",
    "data-name": "Path 11130",
    d: "M17.454,4.029V17.74a2.815,2.815,0,0,1-2.794,2.794H5.172A2.774,2.774,0,0,1,2.378,17.74V4.029H.884a.65.65,0,0,1,0-1.3H5.432V2.014A2.025,2.025,0,0,1,7.447,0h4.939A2.025,2.025,0,0,1,14.4,2.014v.715h4.549a.65.65,0,0,1,0,1.3Zm-9.1,7.6v7.6h3.054v-7.6h1.3v7.6H14.66a1.512,1.512,0,0,0,1.495-1.495V4.029H3.678V17.74a1.471,1.471,0,0,0,1.495,1.495H7.057v-7.6Zm-1.625-8.9H13.1V2.014a.721.721,0,0,0-.715-.715H7.447a.721.721,0,0,0-.715.715Z",
    transform: "translate(-0.25)",
    fill: "var(--mainColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon2);
export default __webpack_public_path__ + "static/media/deleteIcon2.d7f8588cc316882f97c4e9a091249d9a.svg";
export { ForwardRef as ReactComponent };